import { ContainerModule } from 'inversify';
import { containerModule as UKModule } from './bindings';
import { containerModule as SpainModule } from './variants/spain/bindings';
import { containerModule as ItalyModule } from './variants/italy/bindings';
import { containerModule as DenmarkModule } from './variants/denmark/bindings';
import { containerModule as SwedenModule } from './variants/sweden/bindings';
 import { queryStringParams } from '@game-studio/arcade-base';

export type Bindings = { gameBindings: ContainerModule; regionBindings?: ContainerModule; };
export function getBindings(): Bindings {
    const bindings: Bindings = { gameBindings: UKModule }
    const region = queryStringParams.locale ?? 'uk';

    switch (region) {
        case 'es-es':
            bindings.regionBindings = SpainModule;
            break;
        case 'it-it':
            bindings.regionBindings = ItalyModule;
            break;
        case 'dk-dk':
            bindings.regionBindings = DenmarkModule;
            break;
        case 'se-se':
            bindings.regionBindings = SwedenModule;
            break;
        default:
            bindings.regionBindings = undefined;
            break;
    }

    return bindings;
}
